import { faClock, faSearch } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DateDisplay } from "components/Shared/DateDisplay";
import { TariffTypeEnumDisplay } from "components/Shared/TariffTypeEnumDisplay";
import React, { useEffect, useState } from "react";
import Tooltip from '@mui/material/Tooltip';
import {
  AvailableFareConnectionModel,
  AvailableFareLegModel,
  FareInfoBoxView,
  TariffTypeEnum,
  TravelHeaderMin,
  TravelTimeView,
} from "WebApiClient";
import { FareInfoBoxModal } from "./Fare.InfoBoxModal";
import _ from "lodash";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

interface FareInfoBoxProps {
  Info: FareInfoBoxView;
  ShowDetails: boolean;
  ToggleFare: (fareIndexSingle: number, legBoolString: string) => void;
  FareIndex: number;
  SelectedConnections: number[];
  Legs: AvailableFareLegModel[];
  Status: boolean;
  travelHeader: TravelHeaderMin;
}

const FareInfoBox: React.FC<FareInfoBoxProps> = (props) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [expiredModalOpen, setExpiredModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ code: "", html: "" });
  const TotalFlightTime: TravelTimeView = GetTotalFlightTime();

  const ToggleExpiredModal = (e?: React.MouseEvent<any>) => {
    if (e) e.stopPropagation();
    setExpiredModalOpen((prev) => !prev);
  };

  function GetTotalFlightTime(): TravelTimeView {
    let result: TravelTimeView = {
      daysStayOver: 0, // No recalculation, just keeps original format
      minutes: 0,
      addHours: 0,
      hours: 0,
    };

    props.SelectedConnections.forEach((c, i) => {
      let legTime: TravelTimeView | undefined;
      if (props.Status) {
        legTime = props.Legs[i]?.connections.find(
          (connection: AvailableFareConnectionModel) => connection.index === c
        )?.connectionHeader?.legTravelTime;
      } else {
        legTime =
          props.Legs[i]?.connections[c]?.connectionHeader?.legTravelTime;
      }

      if (legTime) {
        result.minutes += legTime.minutes;
        result.addHours += legTime.addHours; // Already includes rolled-over hours
      }
    });

    // Adjust minutes to addHours and roll over
    if (result.minutes >= 60) {
      result.addHours += Math.floor(result.minutes / 60);
      result.minutes %= 60;
    }

    // Compute hours and daysStayOver
    result.daysStayOver = Math.floor(result.addHours / 24);
    result.hours = result.addHours % 24;

    return result;
  }

  useEffect(() => {
    GetTotalFlightTime();
  }, [props.SelectedConnections, props.Status]);


  function GetTariffTypes(): TariffTypeEnum[] {
    let result: TariffTypeEnum[] = [];
    props.Legs.forEach((l) => {
      const tarifftype = l.legFareInfo?.tariffType;
      if (tarifftype) {
        if (!result.some((e) => e === tarifftype)) {
          if (tarifftype !== TariffTypeEnum.None) {
            result.push(tarifftype);
          }
        }
      }
    });
    return result;
  }

  function GetFareTypes(): { code: string; html: string }[] {
    const result: { code: string; html: string }[] = [];

    props.Legs.forEach((l) => {
      const raw = l.fareTypeInformation.salesPreferenceDisplayName || l.fareTypeInformation.originalFareType;
      const parsed = splitContent(raw);
      if (parsed.code && !result.some((r) => r.code === parsed.code && r.html === parsed.html)) {
        result.push(parsed);
      }
    });

    return result;
  }

  const fareTypes = GetFareTypes();
  const tariffTypes = GetTariffTypes();
  function splitContent(str: string | undefined): { html: string; code: string } {
    let html = "";
    let code = "";

    if (str) {
      if (str.includes("|")) {
        [html, code] = str.split("|");
      } else {
        code = str;
      }

      // Remove escaped quotes
      code = code.replace(/\\"/g, '"');
      html = html.replace(/\\"/g, '"');
    }

    return { html, code };
  }
  const isHtmlMeaningful = (html: string): boolean => {
    return html.replace(/<[^>]*>/g, '').trim().length > 0;
  };

  return (
    <div className="col-12 px-0 px-md-2 col-md-3" onClick={() => props.ToggleFare(props.FareIndex, "showLeg")}>
      <div className={`fare__single_fare_infobox bg-white mb-2 ${props.ShowDetails ? "boxShadow-light mb-md-3" : ""
        }`}
      >
        <div className="row">
          <div className="col-12 mb-2 mt-2 mt-md-0">
            <span
              style={{ color: "black" }}
              className="float-end salespref badge clickme"
              onClick={(e) => {
                e.stopPropagation();
                setModalOpen(!modalOpen);
              }}
            >
              <span>
                {props.Info.salesPreferencePriority !== null &&
                  props.Info.salesPreferencePriority !== undefined &&
                  props.Info.salesPreferencePriority !== 0 && (
                    <span>{props.Info.salesPreferencePriority} </span>
                  )}
                <span>
                  <FontAwesomeIcon icon={faSearch} />
                </span>
              </span>
            </span>

            <div className="">
              {" "}
              <FontAwesomeIcon icon={faClock} />
              <Tooltip
                title={
                  <span>Total time</span>
                }
              >
                <span>
                  {TotalFlightTime.addHours}h{" "}
                  {TotalFlightTime.minutes}m
                </span>
              </Tooltip>

              {props.travelHeader.flightTime && <span style={{ marginLeft: '4px', marginRight: '4px' }}>||</span>}
              <Tooltip
                title={
                  <span>Flight time</span>
                }>
                <span>
                  {props.travelHeader.flightTime}
                </span>
              </Tooltip>
            </div>
            <div className="infobox_value d-flex">
              <span className="infobox_item"> FARE TYPE: </span>{"  "}
              {/* <span className="outerSpan" dangerouslySetInnerHTML={{ __html: salesPreferenceDisplayNameCode }} onClick={() => ToggleExpiredModal} /> */}
              <div className="d-flex">
                {fareTypes.map((ft, index) => (
                  <div key={ft.code + index} className="fareTypeItem">
                    <span
                      // type="button"
                      className="outerSpan"
                      dangerouslySetInnerHTML={{ __html: ft.code }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (ft.html && isHtmlMeaningful(ft.html)) {
                          setModalContent({ code: ft.code, html: ft.html });
                          setExpiredModalOpen(true);
                        }
                      }}
                      style={{
                        all: 'unset',         // remove all browser styles
                        cursor: ft.html && isHtmlMeaningful(ft.html) ? 'pointer' : 'default',
                        display: 'inline',
                      }}
                      title={ft.html && isHtmlMeaningful(ft.html) ? "Click to view more" : ""}
                    /> {index !== fareTypes.length - 1 && <span>||&nbsp;</span>}
                  </div>
                ))}
              </div>

              <Modal isOpen={expiredModalOpen} toggle={ToggleExpiredModal} className="confirmationError" centered>
                <ModalHeader toggle={ToggleExpiredModal}>
                  <span dangerouslySetInnerHTML={{ __html: modalContent.code }} />
                </ModalHeader>
                <ModalBody>
                  <div dangerouslySetInnerHTML={{ __html: modalContent.html }} />
                </ModalBody>
                <ModalFooter>
                  <Button onClick={ToggleExpiredModal} color="primary">OK</Button>
                </ModalFooter>
              </Modal>
              {tariffTypes.length > 0 && tariffTypes.map((e) => TariffTypeEnumDisplay(e)).join(",")}
            </div>
          </div>
          {props.ShowDetails && (
            <React.Fragment>
              <div className="col-12 mb-2">
                <div className="infobox_item">QUERY | BOOKING GDS</div>
                <div className="infobox_value">
                  {props.Info.queryGDS_BookingGDSDisplayResult}
                </div>
              </div>
              <div className="col-12">
                <div className="infobox_item">QUERY | BOOKING PCC</div>
                <div className="infobox_value">
                  {props.Info.queryPccs?.join(",")} |{" "}
                  {props.Info.bookingPccs?.join(",")}
                </div>
              </div>
              <div className="col-12">
                <div className="infobox_item">LAST TICKETING DATE:</div>
                <div className="infobox_value">
                  <DateDisplay date={props.Info.lastTicketingDate} />
                </div>
              </div>
              <div className="col-12">
                <div className="infobox_item">Source:</div>
                <div className="infobox_value">
                  {props.Info.sources?.join(",")}
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
      {modalOpen && (
        <FareInfoBoxModal
          IsOpen={modalOpen}
          Toggle={() => {
            setModalOpen(!modalOpen);
          }}
          Info={props.Info}
          Legs={props.Legs}
          SelectedConnections={props.SelectedConnections}
        ></FareInfoBoxModal>
      )}
    </div>
  );
};
export default FareInfoBox;
